var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecapIconBnf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 16.5002L18.216 17.6179C19.6034 18.0425 20.6341 19.1554 20.9763 20.5101C21.1115 21.0458 20.6489 21.5002 20.0936 21.5002H3.90639C3.35107 21.5002 2.88845 21.0458 3.02375 20.5101C3.36593 19.1554 4.39659 18.0425 5.78401 17.6179L9.5 16.5002V14.5624C7.71916 13.1686 6.5 11.5 6.5 7.91681C6.5 4.32696 8.45474 2.5 11.4923 2.5C13.6433 2.5 14.5385 3.5 14.5385 3.5C17.0769 3.5 17.5 5.59719 17.5 7.91681C17.5 11.5 16.2808 13.1686 14.5 14.5624V16.5002Z",
    stroke: "#5754E5",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecapIconBnf);
export default __webpack_public_path__ + "static/media/recapIconBnf.283f01dd93f54bd6974f834482732e83.svg";
export { ForwardRef as ReactComponent };